import './ChatWidget.css';
import { useState } from 'react';

const ChatWidget = () => {
  const [chatOpen, setChatOpen] = useState(false);

  const toggleChat = () => {
    setChatOpen(!chatOpen);
  };

  return (
    <>
      <div className="chat-widget">
  <div className="chat-icon" onClick={toggleChat}>
   
   <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
   
    <path
      d="M4 4.5C4 3.12 5.12 2 6.5 2H14.5C15.88 2 17 3.12 17 4.5V9.5C17 10.88 15.88 12 14.5 12H9L6 15V12H6.5C5.12 12 4 10.88 4 9.5V4.5Z"
      fill="#FFFFFF"
    />

   
    <path
      d="M8 9.5C8 8.12 9.12 7 10.5 7H18.5C19.88 7 21 8.12 21 9.5V14.5C21 15.88 19.88 17 18.5 17H13L10 20V17H10.5C9.12 17 8 15.88 8 14.5V9.5Z"
      fill="#FFFFFF"
    />

   
    <circle cx="13" cy="12" r="1" fill="#1677ff" />
    <circle cx="15.5" cy="12" r="1" fill="#1677ff" />
    <circle cx="18" cy="12" r="1" fill="#1677ff" />
  </svg>
  </div>

  <div className={`chat-bubble ${chatOpen ? 'open' : ''}`}>
    <p className="chat-title">We're Online!</p>
    <p className="chat-message">How may I help you today?</p>
  </div>
</div>

      {/* Mobile Auth Buttons */}
      <div className="mobile-auth-buttons">
        <button className="mobile-btn-signup" onClick={() => window.open('https://web.theplatformapi.com/create-company-user?companyName=TREDIXO&isDemo=false&parentId=6', '_blank')}>
          Sign Up
        </button>
        <button className="mobile-btn-login" onClick={() => window.open('https://web.theplatformapi.com/login', '_blank')}>
          Login
        </button>
      </div>

      {/* <div className="whatsapp-widget">
        <MessageCircle size={32} />
      </div> */}
      {/* Right WhatsApp Floating Button */}
      <a
        href="https://wa.me/8421371803"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-widget"
        aria-label="Chat on WhatsApp"
      >
        {/* Exact WhatsApp SVG */}
        <svg
          width="48"
          height="48"
          viewBox="0 0 32 32"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16.003 3C9.373 3 4 8.373 4 15.003c0 2.646.861 5.088 2.323 7.063L4 29l7.128-2.293a11.95 11.95 0 0 0 4.875 1.017h.001c6.63 0 12.003-5.373 12.003-12.003C28.007 8.373 22.634 3 16.003 3zm0 21.754a9.69 9.69 0 0 1-4.946-1.357l-.354-.211-4.23 1.36 1.38-4.118-.23-.377a9.684 9.684 0 0 1-1.487-5.148c0-5.37 4.368-9.737 9.737-9.737 5.37 0 9.737 4.368 9.737 9.737 0 5.37-4.368 9.737-9.737 9.737zm5.342-7.292c-.292-.146-1.729-.853-1.996-.949-.266-.097-.46-.146-.654.146-.195.292-.751.949-.92 1.146-.17.195-.34.219-.632.073-.292-.146-1.233-.455-2.35-1.45-.868-.774-1.454-1.73-1.625-2.022-.17-.292-.018-.45.128-.595.131-.13.292-.34.438-.51.146-.17.195-.292.292-.487.097-.195.049-.365-.024-.51-.073-.146-.654-1.577-.895-2.16-.235-.564-.474-.487-.654-.496l-.558-.01c-.195 0-.51.073-.778.365-.266.292-1.022.998-1.022 2.43 0 1.433 1.047 2.817 1.193 3.012.146.195 2.063 3.152 5.002 4.421.699.302 1.244.482 1.668.617.7.223 1.336.192 1.84.116.561-.084 1.729-.707 1.972-1.39.243-.683.243-1.268.17-1.39-.073-.121-.266-.195-.558-.34z"/>
        </svg>
      </a>
    </>
  );
};

export default ChatWidget;
